export default __webpack_public_path__ + "static/media/penink06.bfdcea5f.png";